import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/loading.svg'


const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "title-4 text-center" }, "Detail du justificatif fiscal", -1)
const _hoisted_3 = {
  key: 0,
  class: "errors"
}
const _hoisted_4 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_5 = { class: "form-content mt-1" }
const _hoisted_6 = { class: "form-fields" }
const _hoisted_7 = { class: "field form-row" }
const _hoisted_8 = {
  key: 0,
  class: "field-header"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "naative-states-year" }, "Conducteur", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "current" }, "Moi", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "all" }, "Tous", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "field form-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "field-header" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "naative-states-year" }, "Période")
], -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  class: "btn btn-primary mt-1",
  type: "submit"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Télécharger ")
const _hoisted_19 = {
  key: 1,
  class: "spinner"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "Spinner"
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]

import { request } from "@/domains/api/api";
import { useLoading } from "@/domains/app/loading";
import { useUser } from "@/domains/auth/user";
import { ROLE_ADMIN } from "@/domains/cruds/users/users";
import { ref } from "vue";
import { read as readXSLX, writeFile as writeXSLX } from "xlsx";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser();

const { loading, setLoading } = useLoading("users.idle-users");
const error = ref<string | null>(null);
const warning = ref<string | null>(null);

let currentYear = new Date().getUTCFullYear();
const availableYears: number[] = [];
for (let i = 0; i < 10; i++) {
    if (currentYear - i < 2023) break;
    availableYears.push(currentYear - i);
}
const selectedYear = ref(currentYear);
const selectedUser = ref<"current" | "all">("current");

function download() {
    error.value = null;
    warning.value = null;
    if (!user.value || loading.value) return;
    setLoading(true);

    request<string>("exports/km-report-details", "get", () => null, {
        year: selectedYear.value,
        ...(selectedUser.value === "current" ? { user_id: user.value.id } : {}),
    })
        .then((rs) => {
            if (!rs) return (error.value = "Aucune fiche trouvée");
            const tmp = readXSLX(rs, { type: "string" });
            return writeXSLX(tmp, `rapport-${selectedYear.value}.xlsx`, {
                type: "base64",
            });
        })
        .catch((e) => {
            console.log(e);
            error.value = "Une erreur est survenue";
        })
        .finally(() => setLoading(false));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form mb-1",
    action: "",
    onSubmit: _withModifiers(download, ["prevent"])
  }, [
    _hoisted_2,
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(error.value), 1)
        ]))
      : _createCommentVNode("", true),
    (warning.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(warning.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_unref(user)?.roles.includes(_unref(ROLE_ADMIN)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true),
          (_unref(user)?.roles.includes(_unref(ROLE_ADMIN)))
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 1,
                class: "field__widget",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUser).value = $event))
              }, _hoisted_13, 512)), [
                [_vModelSelect, selectedUser.value]
              ])
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("select", {
            name: "idle-users-year",
            id: "idle-users-year",
            class: "field__widget",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedYear).value = $event))
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availableYears, (year) => {
              return _createElementVNode("option", {
                value: year,
                key: year
              }, _toDisplayString(year) + " (fiches sur 01/01/" + _toDisplayString(year - 1) + " - 31/12/" + _toDisplayString(year - 1) + ") ", 9, _hoisted_16)
            }), 64))
          ], 512), [
            [_vModelSelect, selectedYear.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("button", _hoisted_17, [
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_18
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
    ])
  ], 40, _hoisted_1))
}
}

})